
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps } from 'next'
import React, { useMemo } from 'react'

import ListingDetail from '@/containers/ListingDetail'
import { ListingNotFound } from '@/containers/ListingNotFound'
import { CateCity, CitiesProvider, useCities } from '@/context/Cities'
import ListingsMapHead from '@/heads/listings-map'
import { listingRedirectPath } from '@/i18n-routes'
import { getCitiesByArea } from '@/page-commons/citiesQuery'
import { fetchListingBySlugAndZone, ListingCate } from '@/page-commons/listingBySlug'
import { ListingsByCityPage } from '@/page-commons/ListingsByCityPage'
import { getZoneFromSegment } from '@/page-commons/ListingsByCityPage/utils'
import { CanonicalFilter } from '@/types/filter'
import { AreaDescription, Zone } from '@/types/graphql-generated-types'
import { CardDataListing, CardDataPriority } from '@/types/property-card'
import { toSession, UserWithKratosId } from '@/utils/auth/auth-client-ssr'
import citiesMapper, { areaParamDecoder, findCity } from '@/utils/cities-mapper'
import { canonicalFilters, getPageTypeFromParams } from '@/utils/get-page-type-from-params'
import logger from '@/utils/logger'
import { NearbyProperty } from '@/utils/nearby-properties-helper'

type Props = {
  areas: AreaDescription[]
  cities: CateCity[]
  city?: string
  currentZone: Zone
  filter?: CanonicalFilter

  geoSlugs?: string[]
  listing: ListingCate | null
  nearbyProperties: NearbyProperty[]
  pageType: ReturnType<typeof getPageTypeFromParams>
  similarListings: CardDataListing[]
  similarPriorities: CardDataPriority[]
  user?: UserWithKratosId
  zone?: string
}

const ZoneAndSlugPage: React.FC<Props> = (props) => {
  const cities = useCities()
  const zones = useMemo(() => (cities.router.city || cities.router.area).city_zones || [], [cities])

  if (props.pageType === 'detail' && props.listing === null) {
    return <ListingNotFound />
  }

  switch (props.pageType) {
    case 'zone':
      return (
        <>
          <ListingsMapHead zone={getZoneFromSegment(zones, props.zone)} />
          <ListingsByCityPage
            canonicalFilter={undefined}
            geoSlugs={props.geoSlugs}
            user={props.user || undefined}
            zoneSlugSegment={props.zone}
          />
        </>
      )
    case 'canonical-filter':
      return (
        <>
          <ListingsMapHead canonicalFilter={props.filter} />
          <ListingsByCityPage canonicalFilter={props.filter} city={props.city} user={props.user || undefined} />
        </>
      )
  }

  return (
    <ListingDetail
      cities={cities}
      listing={props.listing}
      nearbyProperties={props.nearbyProperties}
      similarListings={props.similarListings}
      similarPriorities={props.similarPriorities}
    />
  )
}

const Page: React.FC<Props> = (props) => {
  return (
    <CitiesProvider areas={props.areas} cities={props.cities}>
      <ZoneAndSlugPage {...props} />
    </CitiesProvider>
  )
}

 const _getServerSideProps: GetServerSideProps = async (ctx) => {
  const cities = await getCitiesByArea(ctx.locale, areaParamDecoder(ctx.params.city))
  const areas = cities.filter((city) => city.referenceArea === city.slug)

  const currentCity = findCity(areaParamDecoder(ctx.params.city), cities)

  const currentZone = currentCity && citiesMapper.findZone(ctx.params.params[0], currentCity.city_zones) // validate zone over the current city

  const pageType = getPageTypeFromParams(ctx.locale as Locale, ctx.params.city, currentZone, ctx.params.params, cities)

  if (pageType === 'not-found') {
    return { notFound: true }
  }

  if (pageType === 'detail') {
    const slug = [...(ctx.params.params as string[])].reverse()[0]
    const zoneOrCitySlug = typeof currentZone !== 'undefined' ? currentZone.slug : currentCity.slug
    const listing = await fetchListingBySlugAndZone(slug, zoneOrCitySlug)

    if (typeof listing === 'undefined') {
      ctx.res.statusCode = 410
      return {
        props: {
          areas,
          cities,
          listing: null,
          pageType,
          similarPriorities: [],
          similars: [],
        },
      }
    }

    return {
      redirect: {
        destination: `/${listingRedirectPath}/${listing.id}/`,
        permanent: false,
      },
    }
  }

  logger.info(
    { channel: 'lisa.accessLog' },
    `GET /${ctx.locale}/${ctx.params.home}/${ctx.params.city}/${ctx.params.params[0]}/ [home][city][..params]{zone}`
  )

  const zoneProps = {
    ...(pageType === 'zone' ? { geoSlugs: [currentCity.slug, currentZone?.slug] } : {}),
    ...(pageType === 'zone' ? { zone: currentZone?.slug.split('/')[2] } : {}),
  }

  const filterProps = {
    ...(pageType === 'canonical-filter'
      ? { filter: canonicalFilters.find((cF) => cF.slug[ctx.locale] === ctx.params.params[0]) }
      : {}),
  }

  const { ory_kratos_session } = ctx.req.cookies
  const user = await toSession(ory_kratos_session)

  return {
    props: {
      areas,
      cities,
      city: ctx.params.city,
      pageType,
      ...filterProps,
      ...zoneProps,
      user,
    },
  }
}

export default Page


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[home]/[city]/[...params]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  